module.exports = __webpack_public_path__ + "static/banner@2x-d024d2ee6ad5df56a7d705867b119e7b.jpg";